
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/bin/prospections",
      function () {
        return require("private-next-pages/dashboard/bin/prospections.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/bin/prospections"])
      });
    }
  